import React, { useEffect } from "react";
import clsx from "clsx";
import { Dropdown } from "react-bootstrap";
import HeaderDropdownToggle from "../content/CustomDropdowns/HeaderDropdownToggle";
import { ReactComponent as PictureIcon } from "../../../_metronic/layout/assets/layout-svg-icons/Picture.svg";
import { toAbsoluteUrl } from "../../../_metronic";
import { Image } from "primereact/image";
import { Typography } from "@material-ui/core";
import PerfectScrollbar from "react-perfect-scrollbar";
import { saveUserPreferences } from "../../services/usersService";
import { useGlobalData } from "../../../provider/GlobalDataProvider";
const perfectScrollbarOptions = {
  wheelSpeed: 2,
  wheelPropagation: false,
};
function UITheme({ iconType }) {
  const {
    userPreferences,
    invifoThemes,
    companyThemes,
    reload,
    setReload,
  } = useGlobalData();

  useEffect(() => {}, [reload]);

  return (
    <Dropdown
      className="kt-header__topbar-item kt-header__topbar-item--langs"
      drop="down"
      alignRight
    >
      <Dropdown.Toggle as={HeaderDropdownToggle} id="dropdown-toggle-my-cart">
        <span
          className={clsx("kt-header__topbar-icon", {
            "kt-header__topbar-icon--brand": iconType === "brand",
          })}
        >
          <PictureIcon />
        </span>
      </Dropdown.Toggle>
      <Dropdown.Menu className="dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround">
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <PerfectScrollbar
              className="kt-scroll px-5 py-3"
              data-height="325"
              data-mobile-height="200"
              data-scroll="true"
              options={perfectScrollbarOptions}
              style={{ maxHeight: "85vh" }}
            >
              <div className="row mb-3">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Typography
                    align="center"
                    variant="h6"
                    className="kt-font-bolder layout-text"
                  >
                    Invifo Themes
                  </Typography>
                  <Typography
                    align="center"
                    variant="body2"
                    className="layout-text"
                  >
                    Artwork by Hector Simpson & Metronic
                  </Typography>
                </div>
              </div>
              <div className="row">
                {invifoThemes && invifoThemes.length > 0
                  ? invifoThemes.map((theme, index) => (
                      <React.Fragment key={index}>
                        <div className="col-sm-2 col-md-2 col-lg-2 mb-2">
                          <Typography
                            align="center"
                            style={{ cursor: "pointer" }}
                            onClick={async () => {
                              saveUserPreferences({
                                ID: userPreferences.ID,
                                userID: userPreferences.userID,
                                lightAsideSkin: userPreferences.lightAsideSkin,
                                darkAsideSkin: userPreferences.darkAsideSkin,
                                lightText: userPreferences.lightText,
                                darkText: userPreferences.darkText,
                                invifoThemeID: theme.ID,
                                customThemeID: 0,
                                language: userPreferences.language,
                                menuLayout: userPreferences.menuLayout,
                              }).then((response) => {
                                setReload(reload + 1);
                              });
                            }}
                          >
                            <Image
                              src={toAbsoluteUrl(
                                `/media/bg/${theme.imageNameThumbnail}`
                              )}
                              imageClassName={
                                userPreferences.invifoThemeID === theme.ID ||
                                (userPreferences.ID === 0 && theme.ID === 1)
                                  ? "image-selected"
                                  : "image-selected-hover"
                              }
                              imageStyle={{
                                width: "9rem",
                                height: "5rem",
                                borderRadius: "6px",
                              }}
                              alt="Theme"
                              fluid
                            />
                          </Typography>
                          <Typography
                            align="center"
                            className="layout-text mb-3"
                          >
                            {theme.imageDescription}
                          </Typography>
                        </div>
                      </React.Fragment>
                    ))
                  : null}
              </div>
              {companyThemes && companyThemes.length > 0 ? (
                <React.Fragment>
                  <div className="row mb-3">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <Typography
                        align="center"
                        variant="h6"
                        className="kt-font-bolder layout-text"
                      >
                        Company Themes
                      </Typography>
                      <Typography
                        align="center"
                        variant="body2"
                        className="layout-text"
                      >
                        Artwork by Company Administrator
                      </Typography>
                    </div>
                  </div>
                  <div className="row">
                    {companyThemes && companyThemes.length > 0
                      ? companyThemes.map((theme, index) => (
                          <React.Fragment key={index}>
                            <div className="col-sm-2 col-md-2 col-lg-2 mb-2">
                              <Typography
                                align="center"
                                style={{ cursor: "pointer" }}
                                onClick={async () => {
                                  saveUserPreferences({
                                    ID: userPreferences.ID,
                                    userID: userPreferences.userID,
                                    lightAsideSkin:
                                      userPreferences.lightAsideSkin,
                                    darkAsideSkin:
                                      userPreferences.darkAsideSkin,
                                    lightText: userPreferences.lightText,
                                    darkText: userPreferences.darkText,
                                    invifoThemeID: 0,
                                    customThemeID: theme.ID,
                                    language: userPreferences.language,
                                    menuLayout: userPreferences.menuLayout,
                                  }).then((response) => {
                                    setReload(reload + 1);
                                  });
                                }}
                              >
                                <Image
                                  src={
                                    theme.imagePath !== ""
                                      ? theme.imagePath
                                      : null
                                  }
                                  imageClassName={
                                    userPreferences.customThemeID ===
                                      theme.ID ||
                                    (userPreferences.ID === 0 && theme.ID === 1)
                                      ? "image-selected"
                                      : "image-selected-hover"
                                  }
                                  imageStyle={{
                                    width: "9rem",
                                    height: "5rem",
                                    borderRadius: "6px",
                                  }}
                                  alt="Theme"
                                  fluid
                                />
                              </Typography>
                              <Typography
                                align="center"
                                className="layout-text mb-3"
                              >
                                Custom {index + 1}
                              </Typography>
                            </div>
                          </React.Fragment>
                        ))
                      : null}
                  </div>
                </React.Fragment>
              ) : null}
            </PerfectScrollbar>
          </div>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default UITheme;
